import React from "react";
import "./ContributeContainer.css";

function ContributeContainer({ data }) {
  return (
    <>
      {data?.map((item, _) => {
        return (
          <div className="contribute_box_main_container">
            <img
              alt=""
              src={require(`../../assets/images/${item?.img}`)}
              style={{ height: "138px", width: "138px", alignSelf: "center" }}
            />
            <div className="contribute_box_title">{item?.title}</div>
            <div>{item?.content}</div>
          </div>
        );
      })}
    </>
  );
}

export default ContributeContainer;
